// src/services/alertConfigurationsService.ts
import { apiClient } from './apiConfig';
import { AlertConfigData, AlertConfigRecord } from '../types';

export const listAlertConfigurations = async (): Promise<AlertConfigRecord[]> => {
  const response = await apiClient.get<AlertConfigRecord[]>('/alert-configurations');
  return response.data;
};

export const getAlertConfiguration = async (id: string): Promise<AlertConfigRecord> => {
  const response = await apiClient.get<AlertConfigRecord>(`/alert-configurations/${id}`);
  return response.data;
};

export const createAlertConfiguration = async (config: AlertConfigData): Promise<void> => {
  await apiClient.put('/alert-configurations', config);
};

export const updateAlertConfiguration = async (id: string, config: Partial<AlertConfigData>): Promise<void> => {
  await apiClient.put(`/alert-configurations/${id}`, config);
};

export const deleteAlertConfiguration = async (id: string): Promise<void> => {
  await apiClient.delete(`/alert-configurations/${id}`);
};
